module.exports = __webpack_public_path__ + "img/employee-of-the-month.84bb7ed2.webp";